export default __webpack_public_path__ + "static/media/IconAiJoining.11de6d67.svg";